'use strict';

var _ = require('lodash');
var DeleteRuleModalController = function DeleteRuleModalController($scope, rulesStateService, hepService) {
  $scope.removeRules = function () {
    var rulesToRemove = rulesStateService.getSelectedRows();
    if (!_.isEmpty(rulesToRemove)) {
      $scope.$emit('rule-listing:deleteRules', rulesToRemove);
    }
  };
  $scope.maxDeleteCount = function () {
    return hepService.getSimpleHepProperties().MAX_DELETE_COUNT;
  };
};
DeleteRuleModalController.$inject = ['$scope', 'RulesStateService', 'HepService'];
module.exports = DeleteRuleModalController;